/**
 * API Configuration
 * Centralizes all API calls to use the correct base URL
 */

// Base URL for API calls - uses environment variable or falls back to production
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.barberconnect.fr';

// Base URL for SSE connections
export const SSE_BASE_URL = process.env.REACT_APP_SSE || 'https://api.barberconnect.fr';

/**
 * Fetch wrapper that automatically prepends the API base URL
 * @param {string} path - API path (e.g., '/api/v2/location/24')
 * @param {RequestInit} options - Fetch options
 * @returns {Promise<Response>}
 */
export const apiFetch = (path, options = {}) => {
  const url = `${API_BASE_URL}${path}`;
  return fetch(url, {
    ...options,
    credentials: 'include',
  });
};

/**
 * Build full API URL for a given path
 * @param {string} path - API path
 * @returns {string}
 */
export const getApiUrl = (path) => `${API_BASE_URL}${path}`;

/**
 * Build full SSE URL for a given path
 * @param {string} path - SSE path
 * @returns {string}
 */
export const getSseUrl = (path) => `${SSE_BASE_URL}${path}`;
